import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { ProgramAvailablity, ProgramType } from "src/enums";
import { _ } from "src/services";
import { ModalsAction, ProfileDataAction, ProgramViewAction } from "src/store";
import { ProgramViewCountDown } from "../program";
import { Devices, ExternalLink, Package } from "../svg";
import { PlayerOverlayProps } from "./player.overlay.props";
import { Button } from "react-bootstrap";

export const PlayerOverlay: React.FC<PlayerOverlayProps> = ({
  availability,
  hasMessage,
  hideTitle,
  logo,
  message,
  status,
  title,
  streamId,
  otherSession,
  programType,
  channelId,
  packageId,
  programId,
  btnLoading,
  stream,
  qualityConfig,
  submit: buttonText,
  link,
}) => {
  //#region depenencies

  const dispatch = useDispatch();
  const { push, goBack } = useHistory();

  //#endregion

  const renderLoginButton = () => {
    const onLogin = () => dispatch(ModalsAction.showLogin());

    return (
      <button
        onClick={onLogin}
        className="btn btn-primary btn-player player-overlay--cta mx-auto d-table"
      >
        {_("login")}
      </button>
    );
  };

  const renderPackageButton = () => {
    const onOpenPackages = () =>
      packageId && push(`/subscription/${packageId}/${programId}`);

    return (
      <button
        onClick={onOpenPackages}
        className="btn btn-packages btn-player mx-auto d-flex py-1 align-items-center"
      >
        <span className="mr-1 ml-2">{_("buyPackage")}</span>
        <span className="mr-2">
          <Package />
        </span>
      </button>
    );
  };

  const renderIpCheckButton = () => {
    const onCheckIp = () => dispatch(ProgramViewAction.checkIp());

    return (
      <button
        onClick={onCheckIp}
        className="btn btn-primary btn-player player-overlay--cta mx-auto d-table"
      >
        {_("button_check_ip")}
      </button>
    );
  };

  const renderIpCheckDisabledButton = () => {
    if (!btnLoading) return null;
    return (
      <button
        disabled
        className="btn btn-player btn-loading player-overlay--cta mx-auto d-flex align-items-center"
      >
        <span>{_("button_check_ip")}</span>
      </button>
    );
  };

  const renderGetDeivceAccessButton = () => {
    const onSuccess = () =>
      stream &&
      dispatch(
        ProgramViewAction.requestProgramStreamData(stream, qualityConfig)
      );

    const returenToList = () =>
      dispatch(ProfileDataAction.sendDeviceCode(false, onSuccess));

    return (
      <button
        onClick={returenToList}
        className="btn btn-primary btn-player player-overlay--cta mx-auto d-table"
      >
        <span className="mr-1">{_("restoreAccess")}</span>
        <span>
          <Devices />
        </span>
      </button>
    );
  };

  const renderReturnToListButton = () => {
    const returenToList = () =>
      push(programType === ProgramType.ArchiveVideo ? "/archive" : "/");

    return (
      // <button
      //   onClick={returenToList}
      //   className="btn btn-primary btn-player player-overlay--cta mx-auto d-table"
      // >
      //   {_("returnToList")}
      // </button>
      <></>
    );
  };

  const renderRedirectButton = () => {
    return (
      <a
        href={link}
        className="btn btn-primary btn-player player-overlay--cta mx-auto d-table"
      >
        <span className="mr-1">{buttonText}</span>
        <span>
          <ExternalLink />
        </span>
      </a>
    );
  };

  const renderButton = () => {
    if (availability === ProgramAvailablity.Unauthorized)
      return renderLoginButton();
    if (
      [
        ProgramAvailablity.NeedPackage,
        ProgramAvailablity.QualityNeedPackageCountdown,
        ProgramAvailablity.NeedPackageCountDown,
      ].includes(availability) &&
      programType !== ProgramType.Tv
    )
      return renderPackageButton();
    if (
      [
        ProgramAvailablity.Simultaneous,
        ProgramAvailablity.DeviceAccessTerminated,
      ].includes(availability)
    )
      return renderGetDeivceAccessButton();
    if (
      availability === ProgramAvailablity.NotFound &&
      programType !== ProgramType.Tv
    )
      return renderReturnToListButton();
    if (
      availability === ProgramAvailablity.Missing &&
      programType !== ProgramType.Tv
    )
      return renderReturnToListButton();
    if (availability === ProgramAvailablity.Forbiden)
      return btnLoading ? renderIpCheckDisabledButton() : renderIpCheckButton();
    if (availability === ProgramAvailablity.ForbidenNoButton)
      return renderIpCheckDisabledButton();
    if (availability === ProgramAvailablity.MustRedirect)
      return renderRedirectButton();
  };

  if (!hasMessage) return null;

  const showCountDown = [
    ProgramAvailablity.QualityNeedPackageCountdown,
    ProgramAvailablity.NeedPackageCountDown,
    ProgramAvailablity.CountDown,
  ].includes(availability);

  const logoFile = logo
    ? require(`src/assets/static/img/main/${logo}`)
    : undefined;

  return (
    <div className="player-overlay" style={{ color: "#fff" }} dir="ltr">
      <div className="media-player--locked">
        <div className="player-overlay--artworked-content">
          {!showCountDown && logoFile && (
            <img
              className="player-overlay--artwork d-block mx-auto"
              src={logoFile ? logoFile : ""}
              alt=""
            />
          )}
          <h5
            className="text-rtl text-center player-overlay--title"
            style={{ fontSize: "40px" }}
          >
            {!hideTitle && title}
          </h5>
          {showCountDown && <ProgramViewCountDown />}
          <p
            className="text-rtl text-center player-overlay--message"
            style={{ fontSize: "32px" }}
          >
            {message}
          </p>
          {renderButton()}
          <Button
            onClick={() => push("/")}
            variant="secondary"
            style={{
              backgroundColor: "#393939",
              fontSize: "1.5rem",
              color: "#fff",
              width: "33%",
              marginTop: "20px",
            }}
          >
            بازگشت به صفحه اصلی
          </Button>
        </div>
      </div>
    </div>
  );
};
